export const RECAPTCHA_SITE_KEY = '6LfHYbchAAAAABakzMlXS8VKkdQwa7e-oZLSqlOD';
export const RECAPTCHA_V2_SITE_KEY = '6LcvQtkhAAAAAF_-x9pdXxBAWCMSpDUur5g9UGpO';
